import { extractNumber } from '@cred/shared/utils'

export const validateLoanAmount = (value) => {
  const numberValue = extractNumber(value)
  let error

  if (numberValue < 1000 || numberValue > 100000) {
    error = 'Enter an amount between $1,000 and $100,000.'
  }

  return error
}
